/* eslint-disable no-unused-vars */
import { stokpress } from '../util/helper';
// var StellarAccordion = require( '../components/accordion' );
/* eslint-disable no-undef */

const Product = {};

let productSectionsContainer = document.getElementById( 'js-selected-product-sections' ),
    productInfoContainer = document.getElementById( 'js-selected-product-info' ),
    productSwitchSelector = 'js-change-product',
    productSizeSelector = 'js-change-size',
    ajaxRequestEnable = true;

Product.processChangeProduct = (el) => {
    let url = Product.ajaxUrl + el.dataset.id;

    if (Product.currentLang) {
        url = url + '?lang=' + Product.currentLang;
    }

    Product.processRequest( 'GET', url, el.dataset.url );
}

Product.processRequest = (action, url, targetUrl) => {

    // To avoid double send of ajax request
    if( !ajaxRequestEnable ) {
        return;
    }

    let xhr = new XMLHttpRequest();

    ajaxRequestEnable = false;

	xhr.onreadystatechange = function () {
		if ( xhr.readyState !== XMLHttpRequest.DONE ) { return; }

		if ( xhr.status === 200 ) {
			try {
                let data = JSON.parse( xhr.response );

                Product.outputResult( data, targetUrl );
                ajaxRequestEnable = true;
			}
			catch ( err ) {
                console.log( err );
			}

		}
	};

    xhr.open( action, url, true );
    xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
    xhr.send();
}

Product.outputResult = (data, targetUrl) => {
    if( !data.product ) {
        return;
    }

    window.history.pushState( data, '', targetUrl );
    Product.updateHtml( data );
}

Product.updateHtml = (data) => {
    productInfoContainer.innerHTML = data.product.info;
    productSectionsContainer.innerHTML = data.product.sections;

    if (data.product.current_color.name) {
        $( 'title' ).html( data.product.current_color.name );
    }
    
    Product.init( true );
}

Product.changeProduct = (items) => {
    if (!items) {
        return;
    }

    Array.prototype.forEach.call( items, function (item) {
		item.addEventListener( 'change', function ( event ) {
            window.location.href = event.target.parentElement.dataset.url;
		});
	} );
}

Product.changeSize = (items) => {
    if (!items) {
        return;
    }

    Array.prototype.forEach.call( items, function (item) {
		item.addEventListener( 'change', function () {
            let input = this.querySelector('input:checked'),
                parent = stokpress.findAncestor( input, 'js-dropdown' ),
                button = parent ? parent.querySelector( '.js-selected-label' ) : null;
            
                if (button) {
                    const itemLabel = input.parentNode.querySelector( '.js-item-label' );
                    button.innerHTML = itemLabel ? itemLabel.innerHTML : button.dataset.default_label;
                }
		});
	} );
}

Product.init = (reinit) => {
    if (!productInfoContainer || !productSectionsContainer) {
        return;
    }

    Product.ajaxUrl = productInfoContainer.dataset.url;
    Product.currentLang = productInfoContainer.dataset.lang;
    Product.changeProduct( productInfoContainer.getElementsByClassName(productSwitchSelector) );
    Product.changeSize( productInfoContainer.getElementsByClassName(productSizeSelector) );

    if ( reinit ) {
        $('.js-plus-item').plusItem();
        window.lazyLoadInstance.update();
        window.BackgroundSwicher.refresh();
        window.ProductSelectedSlider.init();
        window.TrustbarSlider.init();        
        window.ProductSlider.init();
        window.FeatureSlider.init();
        window.Video.init();
        window.Cart.init();
    }
}

Product.init(false);
if ( typeof history.pushState !== 'undefined' ) {
    if ( Product.productColors ) {

        let initialColorData = {};
        initialColorData.product = {};
        initialColorData.product.info = productInfoContainer.innerHTML;
        initialColorData.product.sections = productSectionsContainer.innerHTML;

        window.history.replaceState( initialColorData, '', location.pathname );
    }

    window.addEventListener( 'popstate', function ( e ) {
        let data = e.state;

        if ( data && typeof data === 'object' ) {

            setTimeout( function(){
                Product.updateHtml( data );
            }, 500 );
        } else {
            // Product not loaded
        }
    } );
}
window.Product = Product;


// WEBPACK FOOTER //
// ./scripts/components/product.js